/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Contact_Open_WhatsappInputs */

const en_case_contact_open_whatsapp = /** @type {(inputs: Case_Contact_Open_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in WhatsApp`)
};

const pt_br2_case_contact_open_whatsapp = /** @type {(inputs: Case_Contact_Open_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir no WhatsApp`)
};

/**
* | output |
* | --- |
* | "Open in WhatsApp" |
*
* @param {Case_Contact_Open_WhatsappInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_open_whatsapp = /** @type {((inputs?: Case_Contact_Open_WhatsappInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_Open_WhatsappInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_open_whatsapp(inputs)
	return pt_br2_case_contact_open_whatsapp(inputs)
});